export function categorizeBillingGuides(items = []) {
  return {
    FACTURABLES: items.filter((item) => item.seleccionable && !item.advertencias?.length),
    ADVERTENCIAS: items.filter((item) => item.seleccionable && item.advertencias?.length),
    EXCLUIDAS: items.filter((item) => !item.seleccionable),
    TODAS: items,
  };
}

export function getInitialBillingTab(categories) {
  if (categories.FACTURABLES?.length) return 'FACTURABLES';
  if (categories.ADVERTENCIAS?.length) return 'ADVERTENCIAS';
  return 'EXCLUIDAS';
}
